import {
    Box,
    Card,
    CardBody,
    Text,
    useRadio,
    UseRadioProps,
    CardHeader,
    Circle
} from '@chakra-ui/react'
import { FiUserCheck, FiUserX } from 'react-icons/fi'

const ScanningRadioCard = (
    props: UseRadioProps & {
        children: React.ReactNode
    }
) => {
    const { getInputProps, getRadioProps } = useRadio(props)
    const input = getInputProps()
    const checkbox = getRadioProps()

    return (
        <Box as="label">
            <input {...input} />
            <Card
                {...checkbox}
                cursor="pointer"
                borderColor="gray.100"
                borderWidth="1px"
                _checked={{
                    bg: 'brand.50',
                    color: 'brand.400',
                    borderColor: 'brand.600',
                    borderWidth: '2px'
                }}
                _focus={{
                    boxShadow: 'outline'
                }}
                maxW={{ base: 'md', sm: 'sm' }}
                variant="elevated"
                backgroundColor="white"
            >
                <CardHeader>
                    <Circle
                        size="50px"
                        bg="gray.50"
                        borderColor="gray.200"
                        borderWidth="1px"
                    >
                        {props.children === 'Check Out' ? (
                            <FiUserX color="tomato" size={'20px'} />
                        ) : (
                            <FiUserCheck color="green" size={'20px'} />
                        )}
                    </Circle>
                </CardHeader>
                <CardBody>
                    <Text>{props.children}</Text>
                </CardBody>
            </Card>
        </Box>
    )
}

export default ScanningRadioCard
